var CookieConsent = function () {
    if (this.getCookie("cc_show") != "no") {
        this.openNotification();

        ppms.cm.api(
            "setInitialComplianceSettings",
            {
                consents: ["analytics"],
            },
            console.log,
            console.error
        );
    }

    var self = this;

    jQuery("#cookie-consent .cc-option").each(function () {
        if (self.getCookie("cc_" + jQuery(this).data("value")) == "yes") {
            jQuery(this).prop("checked", true);
        }
        else {
            jQuery(this).prop("checked", false);
        }
    });

    jQuery("#cookie-consent .cc-toggle-settings").on("click", function () {
        self.toggleSettings();
        return false;
    });

    jQuery("#cookie-consent .cc-accept-necessary").on("click", function () {
        self.necessary();
        return false;
    });

    jQuery("#cookie-consent .cc-accept-all").on("click", function () {
        self.accept();
        return false;
    });

    jQuery("#cookie-consent .cc-save").on("click", function () {
        self.save();
        return false;
    });
    jQuery(".cookie-consent-open-settings").on("click", function () {
        self.openNotificationWithSettings();
        $('#cookie-consent p > a').trigger("focus");
        return false;
    });

    // accordion-cookie.volt functions
    // fill checkboxes on load
    if (jQuery(".cookie-option").length > 0) {
        jQuery(".cookie-option").each(function () {
            if (self.getCookie("cc_" + jQuery(this).data("value")) == "yes") {
                $(this).prop("checked", true);
            }
        });
    }

    // save on submit
    jQuery(".cookies-submit").on("click", function (ev) {
        ev.preventDefault();
        jQuery(".cookies-status").remove();
        jQuery(".cookie-option").each(function () {
            self.setCookie("cc_" + jQuery(this).data('value'), jQuery(this).is(':checked') ? "yes" : "no");
        });
        jQuery(this).after("<div role='alert' aria-live='polite' class='cookies-status primary-green mb-5'>Nastavitve piškotkov so bile shranjene.</div>");
    });
};

if ($('body').hasClass('cookies')) {
    $('#collapse-3 .table-container table tbody tr td:first-child').each(function () {
        // var checkboxHtml = '<input type="checkbox" tabindex="0" id="cc_checkbox_' + $(this).html() + '" value="0" /><span class="checkmark"></span>'
        var checkboxHtml = '<label>' +
            '<input type="checkbox" tabindex="0" disabled id="cc_checkbox_' + $(this).html() + '" value="0" /><span class="checkmark"></span>' +
            '<span class="sr-only">Oglaševalski piškotki</span></label>';
        $(this).prepend(checkboxHtml);
    });
}

CookieConsent.prototype = {
    _cc: jQuery("#cookie-consent"),
    necessary: function () {
        jQuery("#cookie-consent .cc-option").prop("checked", false);
        this.save();
    },
    accept: function () {
        jQuery("#cookie-consent .cc-option").prop("checked", true);
        this.save();
    },
    save: function () {
        var self = this;

        this.setCookie("cc_show", "no");
        this.setCookie("cc_mandatory", "yes");

        jQuery("#cookie-consent .cc-option").each(function () {
            self.setCookie("cc_" + jQuery(this).data('value'), jQuery(this).is(':checked') ? "yes" : "no");
        });

        this.setPPMSSettings();

        this.hideNotification();
        window.location.reload();
    },
    setPPMSSettings: function () {
        var analyticsStatus = 0;
        var remarketingStatus = 0;

        var ccAnalytics = this.getCookie("cc_analytics");
        if (ccAnalytics === "yes") {
            analyticsStatus = 1;
        }
        var ccMarketing = this.getCookie("cc_marketing");
        if (ccMarketing === "yes") {
            remarketingStatus = 1;
        }

        ppms.cm.api(
            "setComplianceSettings",
            {
                consents: {
                    analytics: {
                        status: analyticsStatus,
                    },
                    remarketing: {
                        status: remarketingStatus,
                    },
                },
            },
            console.log,
            console.error
        );
    },
    _settingsOpen: false,
    toggleSettings: function () {
        if (this._settingsOpen) {
            this.closeSettings(true);
        } else {
            this.openSettings(true);
        }
    },
    openSettings: function (animate) {
        this._settingsOpen = true;
        jQuery("#cookie-consent .cc-actions-toggle").addClass("cc-closed");
        jQuery("#cookie-consent .cc-settings-toggle").removeClass("cc-closed");
    },
    closeSettings: function (animate) {
        this._settingsOpen = false;
        jQuery("#cookie-consent .cc-actions-toggle").removeClass("cc-closed");
        jQuery("#cookie-consent .cc-settings-toggle").addClass("cc-closed");
    },
    openNotification: function () {
        this._cc.show();
        this._cc.css({
            bottom: -1 * this._cc.outerHeight() + "px"
        }).animate({
            bottom: "0px"
        }, "fast", "linear");
    },
    openNotificationWithSettings: function () {
        this.openSettings(false);

        this.openNotification();
    },
    hideNotification: function () {
        var self = this;
        this._cc.animate({
            bottom: -1 * this._cc.outerHeight() + "px"
        }, "fast", "linear", function () {
            self._cc.hide();
        });
    },
    getCookie: function (cname) {
        return lyteeGetCookie(cname);
    },
    getDomainName: function (hostName) {
        return hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1);
    },
    setCookie: function (cname, value) {
        var d = new Date();
        d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        // Set cookie domain to main domain
        var domainName = this.getDomainName(window.location.hostname);
        var domain = ";domain=." + domainName;

        document.cookie = cname + "=" + value + ";" + expires + domain + ";path=/";
    },
};

new CookieConsent();
